import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = {
  id: "nav",
  class: "p-6 text-center"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Acerca de")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_4 = {
  "aria-label": "Código fuente",
  class: "px-4",
  href: "http://gitlab.com/pmartiner/busqueda-giphy-perritos",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_5 = { class: "home container mx-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-center my-7" }, "Buscador de GIFs de perritos 🐕‍🦺", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "mx-auto h-80 rounded",
  alt: "Vue logo",
  src: _imports_0
}, null, -1)
const _hoisted_8 = { class: "container mx-auto px-6" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<p class=\"text-3xl lg:text-4xl xl:text-5xl text-center font-bold pb-2 pt-7\"> ¡Bienvenides! </p><p class=\"text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl\"> En esta aplicación ustedes podrán encontrar los mejores GIFs de perritos. Lo único que tienen que hacer es buscar algo que les venga a la mente cuando piensen en la palabra <code class=\"p-0.5 bg-purple-300 font-bold text-purple-800 dark:bg-purple-600 dark:text-purple-200\">perritos</code>. El buscador agregará como prefijo la palabra <code class=\"p-0.5 bg-purple-300 font-bold text-purple-800 dark:bg-purple-600 dark:text-purple-200\">perritos</code> a tu búsqueda y arrojará unos increíbles GIFs relacionados con estas palabras. </p><p class=\"pb-7 text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl\"> ¡Disfruten de estos animales tan increíbles! </p>", 3)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "search-bar" }, [
  /*#__PURE__*/_createTextVNode(" Buscar GIFs de "),
  /*#__PURE__*/_createElementVNode("code", { class: "p-0.5 bg-purple-300 font-bold text-purple-800 dark:bg-purple-600 dark:text-purple-200" }, "perritos"),
  /*#__PURE__*/_createTextVNode(" 🐶... ")
], -1)
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = {
  key: 0,
  class: "py-4 text-center text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_search_bar = _resolveComponent("search-bar")!
  const _component_recent_search = _resolveComponent("recent-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("nav", _hoisted_1, [
        _createVNode(_component_router_link, {
          class: "font-bold px-4",
          to: "/about"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _hoisted_3,
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fab', 'gitlab'],
            title: "GitLab",
            class: "fill-current"
          })
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("form", {
          role: "search",
          class: "py-4",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearchSubmit && _ctx.onSearchSubmit(...args)), ["prevent"]))
        }, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_search_bar, {
              id: "search-bar",
              value: _ctx.searchQuery,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: `Por ejemplo: ${_ctx.doggiesAdjectives[_ctx.doggiesAdjectives.length * Math.random() | 0]}`
            }, null, 8, ["value", "placeholder"])
          ])
        ], 32),
        (_ctx.recentSearches.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Búsquedas recientes: "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentSearches, (recentSearch) => {
          return (_openBlock(), _createElementBlock("div", {
            key: recentSearch.id
          }, [
            _createVNode(_component_recent_search, {
              "search-link": _ctx.recentSearchLink(_ctx.$event, recentSearch),
              recentSearch: recentSearch,
              onOnFavClick: ($event: any) => (_ctx.onFavClick($event, recentSearch))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" perritos " + _toDisplayString(recentSearch.query), 1)
              ]),
              _: 2
            }, 1032, ["search-link", "recentSearch", "onOnFavClick"])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}